// THIS PLACE IS A MEMORY — the ABC on Sauchiehall Street (design/abc-club.html).
// Data only; the engine is RoomEngine. 'q' = the gig list (rounds), 'z' = the
// table (standings) — "?" info spots on the wall of the Polar Bar.
import type { WorldConfig } from './world';

export const abcWorld: WorldConfig = {
  wrapperClass: 'aworld',
  menuTitle: 'THE VENUE',
  roomVoice: 'ON THE FLOOR',

  rooms: {
    balcony: {
      name: 'THE BALCONY',
      floor: 'BALC',
      map: [
        'WWWWWWWW',
        'WJJZZYYW',
        'W......W',
        'W..c...1',
        'W......1',
        'W.t..t.W',
        'WRRRRRRW',
        'WWWWWWWW',
      ],
      exits: {
        '1': { to: 'polar', r: 1, c: 5, face2: 'd', kind: 'stair', face: 'r', glyph: '▼', name: 'DOWN TO POLAR BAR' },
      },
      entry: [3, 6],
      npc: { '2,3': 'A', '4,2': 'B', '4,5': 'C' },
      blurb: 'Ross has the coats and the whole lighting desk. Lean on the rail and ABC1 is right below.',
    },
    polar: {
      name: 'POLAR BAR',
      floor: 'POLAR',
      map: [
        'WqWzW11WWWWWLbW',
        'V.t.........TbW',
        'V...........=bW',
        'V.t.........TbW',
        'V......g....=bW',
        'V.t.........TbW',
        'V...........=bW',
        'V....FFFF...TbW',
        'Wo...........oW',
        'WW22WWWW33WWWWW',
        'WWWWWWWWWWWWWWW',
      ],
      exits: {
        '1': { to: 'balcony', r: 3, c: 6, face2: 'l', kind: 'stair', face: 'u', glyph: '▲', name: 'UP TO THE BALCONY' },
        '2': { to: 'abc1', r: 3, c: 13, face2: 'l', kind: 'door', face: 'd', glyph: '▼', name: 'THROUGH TO ABC1' },
        '3': { to: 'abc2', r: 2, c: 7, face2: 'd', kind: 'stair', face: 'd', glyph: '▼', name: 'DOWN TO ABC2' },
      },
      entry: [1, 5],
      npc: { '2,5': 'D', '6,8': 'E' },
      blurb: 'Daylight through the arches on one side, bar the full length of the other.',
    },
    abc1: {
      name: 'ABC1 MAIN FLOOR',
      floor: 'ABC1',
      map: [
        '##UUUUUUUUUUU##',
        '#A^^^^^^^^^^^A#',
        '#M~~~~~~~~~~~~#',
        '#M~~G~~~~~G~~~2',
        '#M~~~~XXX~~~~~2',
        '#~~~~~XOX~~~~~#',
        '#~~~~~XXX~~~~~#',
        '#~~~G~~p~~G~~~#',
        '#RRSRRRRRRRSRR#',
        '4aaaaaaaaaaaaa#',
        '4=T==LT==T=L=T#',
        '#bbbbbbbbbbbbb#',
      ],
      exits: {
        '2': { to: 'polar', r: 8, c: 2, face2: 'u', kind: 'door', face: 'r', glyph: '▶', name: 'BACK TO POLAR BAR' },
        '4': { route: '/chat', kind: 'door', face: 'l', glyph: '◀', name: 'OUT TO THE SMOKING AREA' },
      },
      entry: [3, 13],
      npc: { '6,3': 'F', '7,10': 'G', '3,8': 'H' },
      blurb: 'Timber vault overhead, ball dead centre, stage one end. Long bar up the steps behind you.',
    },
    abc2: {
      name: 'ABC2',
      floor: 'ABC2',
      map: [
        '#############',
        '#T=T=b#33####',
        '#lllllllPaHHE',
        '#lllllllPaHHE',
        '#lllllllSaaaE',
        '#llvllllPaHHE',
        '#lllllllPaHHE',
        '#lllllllPaaaE',
        '#############',
      ],
      exits: {
        '3': { to: 'polar', r: 8, c: 8, face2: 'u', kind: 'stair', face: 'u', glyph: '▲', name: 'UP TO POLAR BAR' },
      },
      entry: [2, 7],
      npc: { '3,10': 'I' },
      blurb: 'Ceiling right on top of you, two columns in the way, booths up the step along one side.',
    },
  },

  spots: {
    c: { key: 'c', name: 'THE CLOAKROOM', sub: 'Hand your track to Ross', route: '/submit', phase: 'SUBMITTING', doneField: 'submitted', shut: 'Shut. Coats went in on Wednesday.' },
    g: { key: 'g', name: 'WHOSE IS IT?', sub: 'Name all eight at the bar', route: '/guess', phase: 'VOTING', doneField: 'guesses_done', shut: 'Not open yet. Wait for the lights.' },
    p: { key: 'p', name: 'REQUESTS', sub: 'Put your 10 on the tab', route: '/vote', phase: 'VOTING', doneField: 'points_done', shut: 'The tab is not open yet.' },
    v: { key: 'v', name: 'LIGHTS UP', sub: 'Name the one that killed it', route: '/veto', phase: 'VOTING', doneField: 'veto_done', shut: 'Not yet. Wait for closing time.' },
  },

  info: {
    q: { key: 'q', name: 'THE GIG LIST', sub: 'Everything booked in.', route: '/rounds' },
    z: { key: 'z', name: 'THE TABLE', sub: "Who's owed what. The standings.", route: '/standings' },
  },

  cls: {
    '#': 'w', W: 'pale', '.': 'carpet', o: 'wood', a: 'deck', '~': 'dz', G: 'gobo', V: 'win',
    '=': 'bar', T: 'tap', b: 'barb', L: 'glass', U: 'curt', '^': 'stg', A: 'amp', X: 'trs', O: 'ball',
    C: 'col', P: 'part', H: 'booth', F: 'sofa', t: 'tbl', R: 'rail', S: 'step', M: 'mon',
    l: 'dzlow', E: 'panel', J: 'jog', Z: 'mix', Y: 'rig',
  },
  walk: new Set(['.', 'o', 'a', '~', 'G', 'S', 'l']),
  floor: { balcony: 'carpet', polar: 'wood', abc1: 'dz', abc2: 'dzlow' },
  npcSlots: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],

  palette: {
    id: 'abc',
    disc: '#3a1069',
    pal: { '1': '#12051c', '2': '#ff2e88', '3': '#ffe9f7' },
    palMe: { '1': '#ffb020', '2': '#ff2e88', '3': '#ffe9f7' },
  },

  // The memory voice: warm Glasgow nightclub banter, gently sardonic — not unkind.
  npcLines: [
    'You were at the bar all night, so you were.',
    'That tune got played to death in here.',
    'Everybody claims they were here that night.',
    'Ross has your coat till the lights come up.',
    'Requests are in. No takebacks.',
    'You will no hear yours over this bassline.',
    'Sticky floor, warm cider, best years of our lives.',
    'It hits different at 2am, right enough.',
    "Somebody's getting the lights put on them.",
    'You picked that? On purpose, aye?',
    'Half the room says that one was theirs.',
    'Mind and get a wristband for the balcony.',
  ],

  flavor: {
    T: { title: 'THE BAR', text: 'Four deep and one barman. Same as it ever was.' },
    '=': { title: 'THE BAR', text: 'Four deep and one barman. Same as it ever was.' },
    L: { title: 'THE BAR', text: 'Rows of clean glasses nobody will use.' },
    b: { title: 'BEHIND THE BAR', text: 'Optics, and a fridge nobody has cleaned since 2011.' },
    '^': { title: 'THE STAGE', text: 'Empty tonight. Club night, not a gig.' },
    U: { title: 'THE STAGE', text: 'Curtains drawn. Club night, not a gig.' },
    A: { title: 'THE AMP', text: 'Off tonight. The DJ has the room.' },
    J: { title: 'THE DESK', text: "Ross's lighting and sound rig. Do not touch anything." },
    Z: { title: 'THE DESK', text: "Ross's mixer. Do not touch anything." },
    Y: { title: 'THE DESK', text: "Ross's light rig. Do not touch anything." },
    E: { title: 'THE LIT PANELS', text: 'Backlit the whole length of the wall. Everybody photographs against these.' },
    P: { title: 'THE PARTITION', text: 'Waist high, sticky on top. Somebody has left a pint on it.' },
    H: { title: 'THE BOOTHS', text: 'Up the step, out of the crush. Coats claimed them an hour ago.' },
    O: { title: 'THE MIRRORBALL', text: 'Still turning. It has seen everything.' },
    F: { title: 'THE SOFAS', text: 'Claimed. They are always claimed.' },
    t: { title: 'A TABLE', text: 'Ringed with the ghosts of old pints.' },
    R: { title: 'THE RAIL', text: 'Lean here and the whole floor is below you.' },
  },

  menuLinks: [
    { label: 'THE GIG LIST', sub: 'Everything booked in', route: '/rounds' },
    { label: 'THE SMOKING AREA', sub: 'Off the main bar', route: '/chat' },
    { label: 'SWITCH VENUE', sub: 'Back to the door', route: '/style', ex: true },
  ],

  // Brighter, quicker, major — C–G–Am–F, the memory of a good night out.
  jukebox: {
    root: 130.81,
    chords: [[0, 4, 7], [7, 11, 14], [9, 12, 16], [5, 9, 12]],
    beatMs: 300,
    wave: 'square',
    gain: 0.08,
  },

  // Moving/animated scenes (spec §34). Circuits: Alan + David doing star jumps on
  // the ABC1 floor (animated hold, out of phase). Chase: the bouncer after Alan
  // round ABC2 (flee/chase — movers don't block).
  patrols: [
    {
      id: 'circuits',
      room: 'abc1',
      requires: 'served',
      ms: 380,
      area: { r: [6, 6], c: [2, 4] },
      cast: [
        { k: 'alanwork0', role: 'hold', at: [6, 2], frames: ['alanwork0', 'alanwork1'] },
        { k: 'davwork0', role: 'hold', at: [6, 4], frames: ['davwork0', 'davwork1'] },
      ],
      lines: [
        'ALAN and DAVID have been at this for an hour.',
        'Neither of them is counting.',
        'The bandanas were not discussed beforehand.',
        'DAVID: it is about consistency.',
        'ALAN: it is about the bandanas.',
        'Nobody has asked them to stop.',
      ],
    },
    {
      id: 'chase',
      room: 'abc2',
      requires: 'served',
      ms: 520,
      area: { r: [2, 7], c: [1, 7] },
      cast: [
        { k: 'alan', role: 'flee', from: 'bouncer', bubble: 'MEH' },
        { k: 'bouncer', role: 'chase', target: 'alan' },
      ],
      lines: [
        'ALAN has not broken stride.',
        'The bouncer has been at this since half eleven.',
        'Nobody has explained what Alan did.',
        'ALAN: meh.',
        'THE BOUNCER: come here.',
      ],
    },
  ],
};
